import Image from 'next/image';

import { NextLink } from '@/atoms';
import { Button } from '@/molecules';

import FallBackIMG from '@/assets/images/fallback-product-card.jpg';

import type { FunctionComponent } from 'react';
import type { TypePostHeaderRightProps } from './types';

/**
 * PostHeader
 */
export const PostHeaderRight: FunctionComponent<TypePostHeaderRightProps> = ({
  className = '',
  description,
  title,
  link,
  image,
}: TypePostHeaderRightProps) => (
  <div
    className={`relative flex h-[435px] w-full px-4 py-8 md:px-14 md:py-20 ${className}`}
  >
    <Image
      className="-z-10 object-cover"
      src={image?.src || FallBackIMG.src}
      alt={image?.alt || title}
      fill
    />

    <div className="absolute inset-0 -z-10 bg-gradient-to-t from-black/40" />

    <div className="flex flex-col gap-2 self-end text-white md:max-w-[296px]">
      <h2 className="u-headline u-headline--h2">{title}</h2>
      <p className="u-body u-body--s">{description}</p>

      {link && (
        <NextLink href={link.href} passHref>
          <Button as="a" variant="primary" negative>
            {link.label}
          </Button>
        </NextLink>
      )}
    </div>
  </div>
);

PostHeaderRight.displayName = 'PostHeaderRight';
